var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ICommonState } from '../store/CommonState';
import { Component, VueType } from './core';
let App = class App extends VueType {
    constructor() {
        super(...arguments);
        this.isShow = false;
    }
    created() {
        this.comState.bindGlobalEvent();
        this.isShow = true;
    }
    get pageName() {
        return `pagename=${this.$route.meta.cname}`;
    }
    render() {
        return this.isShow
            ? <keep-alive>
                <router-view class="site_main" _wind={this.pageName}>
                </router-view>
            </keep-alive>
            : null;
    }
};
__decorate([
    ICommonState
], App.prototype, "comState", void 0);
App = __decorate([
    Component
], App);
export { App };
